export default "__VITE_ASSET__89b7f7c0__"